import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
    Form,
    FieldArray,
    FormSection,
    change,
    submit,
    formValueSelector,
    reduxForm,
    getFormSyncErrors,
    SubmissionError,
    unregisterField
} from 'redux-form';
import { Step, Stepper, StepButton, StepContent, RaisedButton, FlatButton, Divider } from 'material-ui';
import _ from 'lodash';
import { STORE_KEYS, CAMPAIGN_FORM_KEYS as FORM_KEYS, WIZZARD_FORM_ID, CAMPAIGN_FORM_ID } from 'dash-front/constants';
import { RuleForm } from '../../components/Form/RuleForm';
import WidgetForm from '../../components/Form/WidgetForm';
import ParamsCuztomizer from './ParamsCuztomizer';
import MessageTemplateArray from './MessageTemplateArray';
import { getEntities } from 'dash-front/selectors';
import { getTriggerPayload } from 'dash-front/triggerConstants';
import Feature from 'dash-front/hoc/withFeature';
// eslint-disable-next-line
import { triggerTypesMap } from 'dash-front/triggerConstants';
import EmojiPicker from '../../components/Form/pickers/REmojiPicker';
import { validateWizzard, getWidgetParamsInitValue } from './schema';
const F = FORM_KEYS;

const MessagePreview = connect(state => ({
    campaignMessage: formValueSelector(CAMPAIGN_FORM_ID)(state, 'defaultMessage'),
    campaignSignature: formValueSelector(CAMPAIGN_FORM_ID)(state, 'signature'),
    ruleMessage: formValueSelector(WIZZARD_FORM_ID)(state, 'message'),
    ruleSignature: formValueSelector(WIZZARD_FORM_ID)(state, 'signature')
}))(({ campaignMessage, ruleMessage, campaignSignature, ruleSignature }) => {
    const message = ruleMessage || campaignMessage;
    const signature = ruleSignature || campaignSignature;
    const result = [message, signature].filter(el => el).join(' ');
    return result ? <span>Message would be: {result}</span> : <span>No text message is provided</span>;
});

const mapStateToProps = state => {
    const widgetSpecs = getEntities(state)[STORE_KEYS.WIDGET_SPECS];
    const widgets = _.get(widgetSpecs, 'widgets');
    return {
        widgets,
        templates: getEntities(state)[STORE_KEYS.TEMPLATES]
    };
};
const WidgetFormEnhanced = connect(mapStateToProps)(WidgetForm);

const initializeAdditionalWidgetParams = (widgetName, triggerType) => (dispatch, getState) => {
    const state = getState();
    const widgets = _.get(getEntities(state), 'widget-specs.widgets', []);
    const widget = widgets.find(w => w.id === widgetName);
    if (widget) {
        const {
            spec: { propTypes }
        } = widget;
        if (Array.isArray(propTypes)) {
            const widgetProperties = propTypes.filter(prop => prop.key !== 'template');
            const triggerPayloadMap = getTriggerPayload(triggerType);
            const initValue = getWidgetParamsInitValue(widgetProperties, triggerPayloadMap);
            const path = F.WIDGET.SECTION + '.' + F.WIDGET.PARAMS.ADDITIONAL.ARRAY;
            dispatch(unregisterField(WIZZARD_FORM_ID, path));
            dispatch(change(WIZZARD_FORM_ID, path, initValue));
        }
    }
    dispatch(change(WIZZARD_FORM_ID, 'messageTemplateIds', []));
};

const SOCCER_SPORT_ID = '1';

const LAST_STEP_INDEX = 3;

const MessageTemplateForm = () => {
    return <FieldArray name="messageTemplateIds" component={MessageTemplateArray} />;
};

class FormWizzard extends React.Component {
    constructor(props, ctx) {
        super(props, ctx);
        this.state = {
            stepIndex: 0
        };
    }

    handleNext = () => {
        if (this.state.stepIndex < LAST_STEP_INDEX) {
            this.setState(({ stepIndex }) => ({
                stepIndex: stepIndex + 1
            }));
        } else {
            this.props.dispatch(submit(WIZZARD_FORM_ID));
        }
    };

    handlePrev = () => {
        this.setState(({ stepIndex }) => ({
            stepIndex: Math.max(0, stepIndex - 1)
        }));
    };

    onStepSelect = stepIndex => () => this.setState({ stepIndex });

    onSave = values => {
        const { errors, onSave } = this.props;
        if (Object.keys(errors || []).length === 0) {
            console.log('no errors in wizzard');
            onSave(values);
            this.setState({ stepIndex: 0 });
        } else {
            console.log('errors in wizzard', errors);
            throw new SubmissionError(errors);
        }
    };

    onTriggerChange = (event, triggerType) => {
        const selected = _.get(triggerTypesMap, `[${triggerType}].conditions`);
        const { dispatch, widgetName } = this.props;
        const conditionsArray = FORM_KEYS.RULES.CONDITIONS.ARRAY;
        if (Array.isArray(selected) && selected.some(e => e.name === 'sportId')) {
            dispatch(change(WIZZARD_FORM_ID, conditionsArray, [{ sportId: SOCCER_SPORT_ID }]));
        } else {
            dispatch(change(WIZZARD_FORM_ID, conditionsArray, [{}]));
        }
        dispatch(initializeAdditionalWidgetParams(widgetName, triggerType));
    };

    onWidgetChange = ({ value }) => {
        const { dispatch, triggerType } = this.props;
        dispatch(initializeAdditionalWidgetParams(value, triggerType));
    };

    renderStepActions = step => {
        const { stepIndex } = this.state;
        return (
            <div style={{ margin: '12px 0' }}>
                <RaisedButton
                    label={stepIndex === LAST_STEP_INDEX ? 'Finish' : 'Continue'}
                    disableTouchRipple
                    disableFocusRipple
                    primary
                    onTouchTap={this.handleNext}
                    style={{ marginRight: 12 }}
                />
                {step > 0 && (
                    <FlatButton
                        label="Back"
                        disabled={stepIndex === 0}
                        disableTouchRipple
                        disableFocusRipple
                        onTouchTap={this.handlePrev}
                    />
                )}
            </div>
        );
    };

    renderStepperForm = () => {
        const { triggerType } = this.props;
        const { stepIndex } = this.state;

        return (
            <Stepper linear={false} activeStep={stepIndex} orientation="vertical">
                <Step>
                    <StepButton onClick={this.onStepSelect(0)}>Select a widget</StepButton>
                    <StepContent>
                        <FormSection name={FORM_KEYS.WIDGET.SECTION}>
                            <WidgetFormEnhanced onChange={this.onWidgetChange} />
                        </FormSection>
                        {this.renderStepActions(0)}
                    </StepContent>
                </Step>
                <Step>
                    <StepButton onClick={this.onStepSelect(1)}>Select a trigger</StepButton>
                    <StepContent>
                        <RuleForm triggerType={triggerType} onTriggerChange={this.onTriggerChange} />
                        {this.renderStepActions(1)}
                    </StepContent>
                </Step>
                <Step>
                    <StepButton onClick={this.onStepSelect(2)}>Customize widget parameters</StepButton>
                    <StepContent>
                        <FormSection name={FORM_KEYS.WIDGET.SECTION}>
                            <FieldArray
                                name={FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.ARRAY}
                                triggerType={triggerType}
                                component={ParamsCuztomizer}
                            />
                        </FormSection>
                        {this.renderStepActions(2)}
                    </StepContent>
                </Step>
                <Step>
                    <StepButton onClick={this.onStepSelect(3)}>Post message</StepButton>
                    <StepContent>
                        <div>
                            <EmojiPicker name="message" multiLine floatingLabelText="Post message" />
                        </div>
                        <div>
                            <EmojiPicker name="signature" floatingLabelText="Signature (hashtags)" />
                        </div>
                        <div style={{ padding: '12px 0px' }}>
                            <MessagePreview />
                        </div>
                        <Divider />
                        <Feature feature="messageServices">
                            <div style={{ padding: '12px 0px' }}>
                                <MessageTemplateForm />
                            </div>
                        </Feature>
                        {this.renderStepActions(3)}
                    </StepContent>
                </Step>
            </Stepper>
        );
    };

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                <Form onSubmit={handleSubmit(this.onSave)}>{this.renderStepperForm()}</Form>
            </div>
        );
    }
}

FormWizzard.propTypes = {
    errors: PropTypes.object,
    triggerType: PropTypes.string,
    onSave: PropTypes.func.isRequired
};

const valueSelector = formValueSelector(WIZZARD_FORM_ID);
const mapStateToPropsFormWiz = state => {
    const triggerType = valueSelector(state, F.RULES.KEY);
    const widgetName = valueSelector(state, 'presentation.name');
    const errors = getFormSyncErrors(WIZZARD_FORM_ID)(state);
    return {
        errors,
        triggerType,
        widgetName
    };
};

export default compose(
    connect(mapStateToPropsFormWiz),
    reduxForm({
        form: WIZZARD_FORM_ID,
        // keepDirtyOnReinitialize: true,
        // destroyOnUnmount: false,
        validate: validateWizzard
    })
)(FormWizzard);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/FormWizzard.js
 **/